module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA7ElEQVQ4T2NkIBMwkqmPAUOjUObBOf/+/Z38YabTRXyGYmjkT9urzMLMfOTvv7/hH2Y6H8KlGatThbIONjD+/1/GyMAY8Wa6/SZsmrH7MXQVp5CI+BUGhv9yjP//p76d4bgAXTPOwBFJP+D7n4lhFQPD/7f/GRkmvJvm2IOsGadGwcxD3kwM/9Yw/Gd4w8DIOOXtdPtOwhoT9nMIczJe+c/AIM/w73/Gu5mOc4lyqlDG/npGBsYKBsb/kW+nO24gKnD4M/cosfxnOfaXkSn8w3S7g0RHh1Dm/jn//jNN/TDD/jxJCYDYJEh2WgUAygNMD5VJqskAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/government_icon_list(1).png
// module id = /o9n
// module chunks = 1